import { defineStore } from 'pinia'
import { ref } from 'vue'

// Global controller for the Image Studio overlay tool. Any component opens it via
// the useImageStudio() composable; it overlays in place and resolves with the
// chosen/edited image (or null on close) — no navigation.
export const useImageStudioStore = defineStore('imageStudio', () => {
    const isOpen = ref(false)
    const options = ref({})
    let resolver = null

    function open(opts = {}) {
        options.value = opts || {}
        isOpen.value = true
        return new Promise((resolve) => { resolver = resolve })
    }
    function apply(result) { isOpen.value = false; const r = resolver; resolver = null; if (r) r(result) }
    function close() { isOpen.value = false; const r = resolver; resolver = null; if (r) r(null) }

    return { isOpen, options, open, apply, close }
})
